module.exports = __webpack_public_path__ + "static/bbis-careers-251cc800edb90b0bafc77bbc2d10a88c.jpeg";